import { render, staticRenderFns } from "./NewMessageTemplateDialog.vue?vue&type=template&id=716103f2&"
import script from "./NewMessageTemplateDialog.vue?vue&type=script&lang=js&"
export * from "./NewMessageTemplateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports